import React from 'react'
import { ScrollingTexts } from '../../../../enums/page_texts/homepage_texts'
import { ScrollingTextContainer, Row } from '../../../../styles/Homepage/ScrollingTexts.style'
import { MobileScrollText } from '../../../../styles/MOBILE/MobileStyles'
import AvailableViews from '../../../../enums/views'

const MobileScrollingTextPublic: React.FC = () => {
    return (
        <ScrollingTextContainer>
            <Row>
                <MobileScrollText variant="h4" direction="right">
                    <a href={AvailableViews.PublicEvents} style={{ all: 'unset' }}>
                        {ScrollingTexts.Row2Text1} · {ScrollingTexts.Row2Text2} · {ScrollingTexts.Row2Text3}
                    </a>
                </MobileScrollText>
            </Row>
        </ScrollingTextContainer>
    )
}

export default MobileScrollingTextPublic